export const beaaHeroImage =
  '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-1.webp';

/** Avatar fechado no rosto da Beaa — usado em chats e bolhas de conversa. */
export const beaaAvatarImage =
  'https://public.readdy.ai/ai/img_res/edited_7ae247def20214f4ae05a3508e3c46c3_09447915.jpg';

export const beaaBrandPoster =
  'https://static.readdy.ai/image/f0e3ea51be3a6053767e026ea9261140/554dcab2b64bc0d9733a4c6b98b49a93.jpeg';

export const beaaWho =
  'A Beaa é a mascote do petbea, criada para representar o Bem Estar Animal da AMMA. Ela simboliza o cuidado, o respeito e o amor por todos os animais, incentivando ações que promovem uma cidade mais consciente, saudável e amiga dos pets.';

export const beaaQuote = 'Animais bem, pessoas melhores, cidades mais felizes!';

export const beaaSmallQuote =
  'Mais que uma mascote, a Beaa é um lembrete diário de que o bem estar animal começa com a nossa escolha.';

export const beaaValues = [
  {
    title: 'Cuidado',
    description: 'Zelar pela saúde e pelo bem-estar de cada animal, todos os dias.',
    icon: 'ri-heart-3-line',
  },
  {
    title: 'Respeito',
    description: 'Reconhecer que cada animal sente e merece ser tratado com dignidade.',
    icon: 'ri-footprint-line',
  },
  {
    title: 'Consciência',
    description: 'Entender que pequenas atitudes constroem cidades mais amigas dos pets.',
    icon: 'ri-leaf-line',
  },
  {
    title: 'Comunidade',
    description: 'Unir pessoas e poder público em torno da causa animal.',
    icon: 'ri-group-line',
  },
];

export const beaaPoses = [
  {
    label: 'Alegria',
    caption: 'Sempre disposta a fazer a diferença com um sorriso.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52.webp',
  },
  {
    label: 'Curiosidade',
    caption: 'Atenta a tudo que envolve o bem-estar dos animais.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-3.webp',
  },
  {
    label: 'Energia',
    caption: 'Corre atrás de cada causa que precisa de ajuda.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-4.webp',
  },
  {
    label: 'Tranquilidade',
    caption: 'Acalma quem chega em busca de um novo amigo.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-2.webp',
  },
];

export const beaaInspirations = [
  'Adotar',
  'Cuidar',
  'Respeitar',
  'Proteger',
  'Convier melhor',
];

export const beaaHistory = [
  {
    period: 'O começo',
    title: 'Nasce uma ideia',
    description:
      'O Bem Estar Animal da AMMA precisava de um rosto: alguém que aproximasse a causa animal do dia a dia do cidadão e transformasse política pública em afeto. Foi assim que a ideia da mascote surgiu.',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    period: 'O nome',
    title: 'BEAA vira símbolo',
    description:
      'O nome nasceu das iniciais de Bem Estar Animal da AMMA: uma palavra curta, fácil de lembrar e cheia de carinho. BEAA, a Beaa.',
    icon: 'ri-quill-pen-line',
  },
  {
    period: 'A identidade',
    title: 'A Beaa ganha forma',
    description:
      'Filhote caramelo e branca, de olhar curioso e orelhas atentas. Ela veste a bandana verde do petbea e carrega a plaquinha dourada com o seu nome — simples, doce e inconfundível.',
    icon: 'ri-palette-line',
  },
  {
    period: 'As ruas',
    title: 'Beaa vai à cidade',
    description:
      'Ela passou a acompanhar campanhas de adoção, castração e guarda responsável, aparecendo em materiais educativos e ações comunitárias por toda Goiânia.',
    icon: 'ri-megaphone-line',
  },
  {
    period: 'Hoje',
    title: 'Mascote oficial',
    description:
      'Hoje a Beaa é o rosto de cada ação do bem estar animal da AMMA, convidando as pessoas a adotar, cuidar, respeitar e proteger todos os animais.',
    icon: 'ri-award-line',
  },
];

export const beaaBrandColors = [
  {
    name: 'Verde Institucional',
    token: 'primary-500',
    role: 'Cor principal da marca, botões e ações de destaque.',
    swatch: 'bg-primary-500',
  },
  {
    name: 'Amarelo Institucional',
    token: 'accent-500',
    role: 'Selos, ênfases e momentos de celebração.',
    swatch: 'bg-accent-500',
  },
  {
    name: 'Verde Sage',
    token: 'secondary-500',
    role: 'Apoio, filtros e elementos secundários.',
    swatch: 'bg-secondary-500',
  },
  {
    name: 'Creme',
    token: 'background-50',
    role: 'Fundo base, cartões e superfícies claras.',
    swatch: 'bg-background-50',
  },
  {
    name: 'Carvão',
    token: 'foreground-950',
    role: 'Textos, títulos e contraste.',
    swatch: 'bg-foreground-950',
  },
];

export const beaaTypography = [
  {
    name: 'Montserrat',
    role: 'Títulos e destaques',
    sample: 'Aa',
    className: 'font-heading font-bold',
    note: 'Pesos 600 a 800',
  },
  {
    name: 'Inter',
    role: 'Textos e interface',
    sample: 'Aa',
    className: 'font-body font-medium',
    note: 'Pesos 400 a 600',
  },
];

export const beaaWallpapers = [
  {
    id: 'wallpaper-alegria',
    name: 'Wallpaper Alegria',
    caption: 'Sempre disposta a fazer a diferença.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52.webp',
  },
  {
    id: 'wallpaper-curiosidade',
    name: 'Wallpaper Curiosidade',
    caption: 'Atenta a tudo que envolve o bem-estar.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-3.webp',
  },
  {
    id: 'wallpaper-energia',
    name: 'Wallpaper Energia',
    caption: 'Corre atrás de cada causa.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-4.webp',
  },
  {
    id: 'wallpaper-tranquilidade',
    name: 'Wallpaper Tranquilidade',
    caption: 'Acalma quem chega em busca de um amigo.',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-2.webp',
  },
];

export const beaaAvatars = [
  {
    id: 'avatar-oficial',
    name: 'Avatar Oficial',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-1.webp',
  },
  {
    id: 'avatar-alegria',
    name: 'Avatar Alegria',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52.webp',
  },
  {
    id: 'avatar-curiosidade',
    name: 'Avatar Curiosidade',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-3.webp',
  },
  {
    id: 'avatar-energia',
    name: 'Avatar Energia',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-4.webp',
  },
  {
    id: 'avatar-tranquilidade',
    name: 'Avatar Tranquilidade',
    image:
      '/img/marca/whatsapp-image-2026-09-23-at-11-47-52-2.webp',
  },
];